import React from 'react';
import { Link } from 'gatsby';
import OptimizedImg from '../OptimizedImage';

export default class BlogCTA extends React.Component {
  state = {
    offer: ''
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    fetch('https://ulamlabs.recruitee.com/api/offers')
      .then(resp => resp.json())
      .then(data => {
        const jobOffers = data.offers;
        const singleOffer =
          jobOffers[Math.floor(Math.random() * jobOffers.length)];
        this.setState({ offer: singleOffer.title });
      });
  }

  render() {
    const { className } = this.props;
    const { offer } = this.state;
    return (
      <div className={`item cta cta-card ${className}`}>
        <OptimizedImg src="cta_photo.png" background className="cta-img" />
        <div className="content">
          <span>We are looking for</span>
          <div className="divider" />
          <span className="cta-title">{offer}</span>
          <Link className="cta-link" to="/careers/">
            Go to careers
          </Link>
        </div>
      </div>
    );
  }
}

BlogCTA.defaultProps = {
  className: ''
};
